import { CheckTreatmentType, IIsiDtoRemovalTreatment, IsiDtoPlControleRestitutionRequest, IsiDtoPlControleRestitutionResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlControleRestitution";
import { IIsiServerToClientBusinessObject } from "../../IsiTypeScript/Isilog.IsiFramework.IsiCommonLibrary";
import { IsiPresentationLogic } from "./IsiPresentationLogic";
import { IsiDtoSelectedRecord } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMark";

export type ParamPlControleRestitution = {
    checkTreatment: CheckTreatmentType,
    values?: IsiDtoSelectedRecord[],
    qteSaisieScan?: number;
    checkPopin?: boolean;
    answerPopin?: boolean;
    associatedViewId?: string,
};

export class IsiPlControleRestitution extends IsiPresentationLogic {

    constructor() {
        super("IsiPlControleRestitutionHandler");
    }


    Restore(dto: ParamPlControleRestitution): Promise<IIsiServerToClientBusinessObject> {

        return new Promise((resolve, reject) => {
            this._Restore(dto).then((getRestoreResult) => {

                if (getRestoreResult.message) {
                    uiCore.showFeedback(getRestoreResult.message, getRestoreResult.hasError);
                }
                resolve(getRestoreResult.getRestoreResult);
            })
                .catch((o) => {
                    if (o.response.error) {
                        uiCore.showErrorMessage(o.response.error.errorMessage);
                    }
                    reject(o);
                });
        });
    }

    /**
     * Marquage du paramétrage
     * @param param
     */
    private _Restore(param: ParamPlControleRestitution): Promise<IsiDtoPlControleRestitutionResponse> {
        return new Promise<IsiDtoPlControleRestitutionResponse>((resolve, reject) => {

            const request = this._createIsiDtoPlRestoreRequestLineRequest(param);

            this.ajax("GetRestore", request, true).then(
                (request: IsiDtoPlControleRestitutionRequest) => {
                    resolve(request.response);
                }
            ).catch((data: IsiDtoPlControleRestitutionRequest) => {
                reject(data);
            });
        });
    }
    RemettreEnlevement(dto: ParamPlControleRestitution): Promise<IIsiDtoRemovalTreatment> {

        return new Promise((resolve, reject) => {
            this._GetRemettreEnlevementResult(dto).then((getRemettreEnlevementResult) => {

                if (getRemettreEnlevementResult.message) {
                    uiCore.showFeedback(getRemettreEnlevementResult.message, getRemettreEnlevementResult.hasError);
                }
                resolve(getRemettreEnlevementResult.getRemettreEnlevementResult);
            })
                .catch((o) => {
                    if (o.response.error) {
                        uiCore.showErrorMessage(o.response.error.errorMessage);
                    }
                    reject(o);
                });
        });
    }
    /* <summary>
       * Contient le résultat de la requete RemettreEnlevement
       * </summary>
       * <returns></returns>*/
    private _GetRemettreEnlevementResult(param: ParamPlControleRestitution): Promise<IsiDtoPlControleRestitutionResponse> {
        return new Promise<IsiDtoPlControleRestitutionResponse>((resolve, reject) => {

            const request = this._createIsiDtoPlRestoreRequestLineRequest(param);
            this.ajax("GetRemettreEnlevement", request, true).then(
                (request: IsiDtoPlControleRestitutionRequest) => {
                    resolve(request.response);
                }
            ).catch((data: IsiDtoPlControleRestitutionRequest) => {
                reject(data);
            });
        });
    }
    /**
     * appel le traitement 'Annuler traitement'
     * @param dto
     */
    AnnulerEnlevement(dto: ParamPlControleRestitution): Promise<IIsiDtoRemovalTreatment> {
        return new Promise((resolve, reject) => {
            this._GetAnnulerEnlevementResult(dto).then((getAnnulerEnlevementResult) => {

                if (getAnnulerEnlevementResult.message) {
                    uiCore.showFeedback(getAnnulerEnlevementResult.message, getAnnulerEnlevementResult.hasError);
                }
                resolve(getAnnulerEnlevementResult.getAnnulerEnlevementResult);
            })
                .catch((o) => {
                    if (o.response.error) {
                        uiCore.showErrorMessage(o.response.error.errorMessage);
                    }
                    reject(o);
                });
        });
    }
    /* <summary>
    * Contient le résultat de la requete AnnulerEnlevement
    * </summary>
    * <returns></returns>*/
    private _GetAnnulerEnlevementResult(param: ParamPlControleRestitution): Promise<IsiDtoPlControleRestitutionResponse> {
        return new Promise<IsiDtoPlControleRestitutionResponse>((resolve, reject) => {

            const request = this._createIsiDtoPlRestoreRequestLineRequest(param);
            this.ajax("GetAnnulerEnlevement", request, true).then(
                (request: IsiDtoPlControleRestitutionRequest) => {
                    resolve(request.response);
                }
            ).catch((data: IsiDtoPlControleRestitutionRequest) => {
                reject(data);
            });
        });
    }
    /**
 * appel le traitement 'Annuler traitement'
 * @param dto
 */
    GetAllListeLigneDem(dto: ParamPlControleRestitution): Promise<string[]> {
        return new Promise((resolve, reject) => {
            this._GetAllListeLigneDem(dto).then((getAllListeLigneResult) => {

                if (getAllListeLigneResult.message) {
                    uiCore.showFeedback(getAllListeLigneResult.message, getAllListeLigneResult.hasError);
                }
                resolve(getAllListeLigneResult.getAllListLigneDemResult);
            }).catch((o) => {
                reject(o);
            });
        });
    }
    /* <summary>
    * Contient le résultat de la requete getAllListeLigneDem
    * </summary>
    * <returns></returns>*/
    private _GetAllListeLigneDem(param: ParamPlControleRestitution): Promise<IsiDtoPlControleRestitutionResponse> {
        return new Promise<IsiDtoPlControleRestitutionResponse>((resolve, reject) => {

            const request = this._createIsiDtoPlRestoreRequestLineRequest(param);
            this.ajax("GetAllListLigneDem", request, true).then(
                (request: IsiDtoPlControleRestitutionRequest) => {
                    resolve(request.response);
                }
            ).catch((data: IsiDtoPlControleRestitutionRequest) => {
                reject(data);
            });
        });
    }
    /*
     * cree le dto correspondant à l'objet ParamPlRestoreRequestLine
     */
    private _createIsiDtoPlRestoreRequestLineRequest(param: ParamPlControleRestitution): IsiDtoPlControleRestitutionRequest {
        return IsiDtoPlControleRestitutionRequest.fromJS({
            values: param.values,
            qteSaisieScan: param.qteSaisieScan,
            checkPopin: param.checkPopin,
            answerPopin: param.answerPopin,
            checkTreatment: param.checkTreatment,
            associatedViewContextId: param.associatedViewId,
            response: IsiDtoPlControleRestitutionResponse.fromJS({
            })
        });
    }
}
